import { tableStandardProps } from "@/utils/componentUtils";
import { Button, Popover, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router";
import ActionTextIcon from "../../../../../../common/components/icons/ActionTextIcon";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import FileTypeIconWithFilename from "../../../../../../common/components/icons/FileTypeIconWithFilename";
import { TableSizes } from "../../../../../../common/constants";
import { formatFileSize } from "../../../../../../common/utils/formatUtils";
import { UUID } from "../../../../../../typings/global";
import { DASHBOARD_ROUTE_PATHS } from "../../../../paths";
import { DashboardNoticeAttachment } from "../../../../types";

interface Props {
  noticeId: UUID;
  attachments: DashboardNoticeAttachment[];
}

export const DashboardNoticeAttachments = ({ noticeId, attachments }: Props) => {
  const { t } = useTranslation();

  const columns: ColumnsType<DashboardNoticeAttachment> = [
    {
      key: "name",
      title: t("common.filename"),
      ellipsis: { showTitle: false },
      width: 350,
      render: (_, record) => (
        <FileTypeIconWithFilename contentType={record.file.contentType} filename={record.file.filename} ellipsis />
      ),
    },
    {
      key: "size",
      title: t("common.filesize"),
      width: 150,
      render: (_, record) => formatFileSize(record.file.size),
    },
    {
      key: "actions",
      align: "right",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <ActionTextIcon
          path={generatePath(DASHBOARD_ROUTE_PATHS.noticeAttachment.to, { id1: noticeId, id2: record.id })}
          target="_blank"
          icon="export"
          color="blue"
          text={t("common.open")}
        />
      ),
    },
  ];

  return (
    <Popover
      placement="bottom"
      content={
        <Table<DashboardNoticeAttachment>
          {...tableStandardProps()}
          columns={columns}
          scroll={{ x: TableSizes.SMALL }}
          dataSource={attachments}
          pagination={false}
        />
      }
      trigger="click"
    >
      <Button size="small" icon={<AntIcon type="paper-clip" />} type="link">
        {t("dashboard.notices.helpers.attachmentsList")}
      </Button>
    </Popover>
  );
};
